import * as React from 'react';
import * as PropTypes from 'prop-types';
import MuiButtonGroup, {ButtonGroupProps} from 'original/ButtonGroup/ButtonGroup';
import {ExtendedButtonProps} from '../Button';
import {Omit} from '../index';
import clsx from 'clsx';
import makeStyles from '../styles/makeStyles';
export * from 'original/ButtonGroup/ButtonGroup';
if (process.env.NODE_ENV !== 'production') {
  MuiButtonGroup['Naked']['propTypes']['variant'] = PropTypes.oneOf(['text', 'outlined', 'contained']);
  MuiButtonGroup['Naked']['propTypes']['color'] = PropTypes.oneOf([
    'default',
    'inherit',
    'primary',
    'secondary',
    'error',
  ]);
}

export interface ExtendedButtonGroupProps extends Omit<ButtonGroupProps, 'color' | 'variant'> {
  color?: ExtendedButtonProps['color'];
  variant?: ExtendedButtonProps['variant'];
}

const useStyles = makeStyles({
  text: {
    boxShadow: 'none',
  },
});

export default React.forwardRef<any, ExtendedButtonGroupProps>(function ButtonGroup(
  {variant, color, className, ...props}: ExtendedButtonGroupProps,
  ref
) {
  const {text} = useStyles();
  return (
    <MuiButtonGroup
      ref={ref}
      color={color as ButtonGroupProps['color']}
      variant={variant as ButtonGroupProps['variant']}
      className={clsx(className, {[text]: variant === 'text'})}
      {...props}
    />
  );
});
